export default __webpack_public_path__ + "static/media/pg-31.0390666f.jpg";